export default __webpack_public_path__ + "static/media/escape-room-logo-RK.4d4c05e7.svg";